import {config} from '../config';

const getI18NLocalizationCodes = () => config.data.i18n.localizationCodes;

const getLanguageCodeByLanguage = (language) => {
    const localizationCodes = getI18NLocalizationCodes();

    return localizationCodes.find(
        (localizationCode) => localizationCode?.language.toUpperCase() === language.toUpperCase()
    );
};

export default {
    getI18NIsFirstDaySunday: () => config.data.i18n.isFirstDaySunday,
    getI18NLocalizationCodes,
    getLanguageCodeByLanguage,
};
